import { IUserAddressBase, IUserBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface ITitularUser extends IUserBase {
  address?: IUserAddressBase;
}

export const showTitularUsersService = async (
  userId: string,
): Promise<ITitularUser> => {
  const { data } = await jhsfBookingsApi.get<ITitularUser>(
    `/users/${userId}/get-titular`,
  );

  return data;
};
